module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col space-y-4 pb-4"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 bg-gray-100 rounded-lg px-5 py-4"
  }, [_c('img', {
    staticClass: "rounded-full",
    attrs: {
      "src": ("/static/integrations/" + (_vm.provider.name) + ".png"),
      "width": "30px",
      "height": "30px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-poppins text-base font-semibold"
  }, [_vm._v("\n      " + _vm._s(_vm.provider.name) + "\n    ")])]), _vm._v(" "), _c('div', [_vm._v("To create a "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("course from")]), _vm._v(" " + _vm._s(_vm.provider.name) + ":")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n      1. Ensure you have a premium school account.\n      "), _c('span', {
    staticClass: "text-primary underline cursor-pointer",
    on: {
      "click": _vm.upgrade
    }
  }, [_vm._v("\n        Upgrade here\n      ")]), _vm._v("\n      if you have a school code.\n    ")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_vm._v("\n      2. Ensure your school IT Admin has approved the connection between\n      Parlay and " + _vm._s(_vm.provider.name) + ".\n    ")]), _vm._v(" "), _c('li', [_vm._v("\n      3. Connect your Parlay account to your\n      " + _vm._s(_vm.provider.name) + " account inside\n      "), _c('span', {
    staticClass: "text-primary underline cursor-pointer",
    on: {
      "click": _vm.connectProfile
    }
  }, [_vm._v("\n        your profile\n      ")]), _vm._v("\n      .\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4a507c35!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/components/instructionsToCreateCourseFromLms.vue
// module id = 2407
// module chunks = 61